import { Controller, useFormContext } from 'react-hook-form'
import styled from 'styled-components'

import TextField, { type TextFieldProps } from '@mui/material/TextField'

type Props = TextFieldProps & {
  name: string
  native?: boolean
  children: React.ReactNode
}

export default function RHFSelect({ name, native, children, ...other }: Props) {
  const { control } = useFormContext()

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Wrapper
          {...field}
          select
          variant="outlined"
          SelectProps={{
            native,
            MenuProps: {
              PaperProps: {
                sx: {
                  backgroundColor: '#f0f0f0',
                  mt: 1,
                  textAlign: 'center',
                },
              },
            },
          }}
          {...other}
        >
          {children}
        </Wrapper>
      )}
    />
  )
}

const Wrapper = styled(TextField)`
  height: 49px;

  .MuiInputBase-root {
    background-color: #f0f0f0;
    border: none;
    border-radius: 12px;
  }

  .MuiOutlinedInput-notchedOutline {
    border: none;
    border-color: none;
  }

  .MuiInputBase-input {
    padding: 12px;

    font-family: NanumSquareNeo-Regular, sans-serif;
    font-size: 15px;
    font-weight: 400;
    line-height: 25px;
    color: #838685;
    word-wrap: break-word;
  }

  .MuiSelect-select {
    display: flex;
    align-items: center;
    padding: 12px;
  }

  .MuiMenuItem-root {
    display: flex;
    align-items: center;
    padding: 10px 20px;
    color: #313634;

    &:hover {
      background-color: #f0f0f0;
    }
  }
`
